// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"8b4439e5","405":"c52fc775","447":"c52fc775","639":"a4ebba04","683":"a4ebba04","932":"c52fc775"}[chunkId] + ".chunk.css";
};